import { Box, DialogContent, DialogContentText, MenuItem, Select } from "@mui/material"
import { UText } from "@/components"
import { useAppSelector } from "@/core/app/hooks";

interface WorkflowDropdownProps {
  workflowId: number | null;
  onChange: (value: number) => void;
  validationMode: boolean
}

const WorkflowDropdown = ({ workflowId, onChange, validationMode }: WorkflowDropdownProps) => {

  const {workflow} = useAppSelector(state=>state.userService)

  return (
    <DialogContent sx={{ p: 0 }}>
      <DialogContentText sx={{ py: 1.5, color: "text.primary" }}>
        Assign Office Workflow
      </DialogContentText>

      <Select
        value={workflowId ?? ""}
        fullWidth
        displayEmpty
        onChange={(e) => onChange(Number(e.target.value))}
        error={!!(validationMode && !workflowId)}
      >
        {workflow.phase.map((item) => (
          <MenuItem key={item.id} value={item.id}  sx={{height: "36px"}}>
            <Box display="flex" alignItems="center" gap={1} width="100%">
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: item.color,
                  flexShrink: 0,
                }}
              />
              <UText variant="body2">{item.value}</UText>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </DialogContent>
  )
}

export default WorkflowDropdown